import styles from "./ReferHowItWorks.module.scss";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReferralProgramService } from "../../../../services/referralProgram.service";
import emptyImage from "../../../../assets/images/referral/referral.png";
import mailIcon from "../../../../assets/images/referral/mail.svg";
import tokenIcon from "../../../../assets/images/referral/token.svg";
import { IReferralMember, ReferralMemberEnum } from "../../../../models/ReferralMember";
import dayjs from "dayjs";

interface IReferHowItWorks {
  userId: string;
  shouldUpdateData: boolean;
}

const ReferHowItWorks: React.FC<IReferHowItWorks> = ({ userId, shouldUpdateData }) => {
  const { t } = useTranslation();

  const [referralMembers, setReferralMembers] = useState<{
    amount: number;
    members: IReferralMember[];
  }>({ amount: 0, members: [] });

  useEffect(() => {
    getReferralMembers();
  }, [shouldUpdateData]);

  const getReferralMembers = async () => {
    try {
      const response = await ReferralProgramService.getAllEReferralMembersByUserId(userId);
      if (response.status === 200 && response.data.members) {
        setReferralMembers(response.data);
      }
    } catch (e) {}
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{t("HowItWorks")}</h3>

      <img className={styles.icon} src={mailIcon} alt={"mail"} />
      <h4 className={styles.subtitle}>{t("InviteFriendsToJoinClassPass")}</h4>
      <p className={styles.text}>{t("InviteFriendsToSignUpThroughYourLink")}</p>

      <img className={styles.icon} src={tokenIcon} alt={"token"} />
      <h4 className={styles.subtitle}>{t("GetRewarded")}</h4>
      <p className={styles.text}>{t("MoreFriendsPlusMoreClasses")}</p>

      <h3 className={styles.tableTitle}>{t("FromReferrals")}</h3>
      <div className={styles.table}>
        <div className={`${styles.tableRow} ${styles.main}`}>
          <div className={`${styles.tableItem} ${styles.first}`}>{t("RecipientEmail")}</div>
          <div className={styles.tableItem}>{t("Date")}</div>
          <div className={styles.tableItem}>{t("EarnedAmount")}</div>
          <div className={styles.tableItem}>{t("Status")}</div>
        </div>
        {referralMembers.members.length === 0 ? (
          <div className={styles.emptyWrapper}>
            <img className={styles.emptyImage} src={emptyImage} alt={"empty"} />
          </div>
        ) : (
          referralMembers.members.map((el) => {
            return (
              <div key={el.id} className={styles.tableRow}>
                <div className={`${styles.tableItem} ${styles.first}`}>{el.memberEmail}</div>
                <div className={styles.tableItem}>{dayjs(el.updatedAt).format("DD/MM/YYYY")}</div>
                <div className={styles.tableItem}>{el.creditsEarned}</div>
                <div className={`${styles.tableItem} ${styles.statusWrapper}`}>
                  <span className={styles[ReferralMemberEnum[el.status]]}>
                    {t(ReferralMemberEnum[el.status])}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ReferHowItWorks;
